<template lang="html">
  <div class="mb-16">
    <div class="mb-6">
      <div class="title py-3 px-4 title-div mt-5">
          <!-- {{$route.params.title}} -->
          <p class="caption mb-0">
              <a href="#/" class="grey--text text--lighten-2">Home / </a>
              <a class="grey--text text--lighten-2">{{$route.params.category}} / </a>
              <a href="#/Media/Visits" class="grey--text text--lighten-2">{{$route.params.contentType}}</a>

          </p>
          <span>{{$route.params.guests}}</span>
      </div>
        <v-progress-linear
        v-if="loadingPage"
        indeterminate
        color="primary"
        ></v-progress-linear>
    </div>
    <v-row row wrap class="mt-3 px-4">
      <v-col md="3" class="pl-0  hidden-sm-and-down">
          <div class="">
          <div
          v-for="(value, key) in navItems"
          :key="key"
          >
              <v-list-group
              dense
              class="elevation-0"
              :value="$route.params.category === key ? true : false"
              >
                  <template v-slot:activator>
                      <v-list-item-content>
                          <v-list-item-title class="px-0">{{key}}</v-list-item-title>
                      </v-list-item-content>
                  </template>
                  <v-list-item
                  v-for="n in value"
                  :key="n"
                  @click="() => {}"
                  link
                  :href="n === 'Laws of the Maldives' ? 'https://mvlaw.gov.mv/dv' : n === 'Laws and Regulations' ? 'https://www.mvlaw.gov.mv' :  `#/${key}/${n}`"
                  >
                      <v-list-item-title class="px-0 font-weight-light" :class="$route.params.contentType === n ? 'info--text' : ''">{{n === "Why Join AGO" ? n + '?' : n}}</v-list-item-title>
                      <v-divider></v-divider>
                  </v-list-item>
              </v-list-group>
              <v-divider></v-divider>
          </div>
          </div>
      </v-col>
      <v-col  cols="11" sm="11" md="8">
        <div v-if="!loadingPage">
          <div  v-if="news.length > 0">
            <p class="display-1 mb-5 primary--text" v-html="news[0].Title.split('#').length > 0 ? news[0].Title.split('#')[1] : ''"></p>
            <p class="caption">{{news[0].Date | moment("DD-MM-YYYY")}}</p>
            <v-img
            :src="`${$url}/downloadfile/${news[0].Files[0] ? news[0].Files[0].ID : ''}`"
            :lazy-src="`${$url}/downloadfile/${news[0].Files[0] ? news[0].Files[0].ID : ''}`"
            contain
            class="transparent mr-4 mt-5 mb-2"
            v-if="getImage(news[0]) != ''"
            >
              <template v-slot:placeholder>
                <v-row
                fill-height
                align-center
                justify-center
                ma-0
                >
                  <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <p class="mt-3 mb-5 ql-editor pa-0">
              <span v-html="news[0].Body"></span>
            </p>
            
          </div>
          <div v-else>
              <p class="title" style="padding-top: 100px">Page Not Found!</p>
          </div>
        </div>
      </v-col>
      <v-col cols="1">
          <div class="sticky">
              <v-btn icon class="my-2" @click="printPage()" color="grey lighten-1">
                  <v-icon>mdi-printer</v-icon>
              </v-btn>
              <br>
              <v-btn :href="`http://www.facebook.com/sharer.php?u=${currentUrl}`" target="_blank" icon class="my-2" color="grey lighten-1">
                  <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <br>
              <v-btn :href="`https://twitter.com/intent/tweet?url=${currentUrl}`" icon class="my-2" target="_blank" color="grey lighten-1">
                  <v-icon>mdi-twitter</v-icon>
              </v-btn>
              <br>
              <v-btn href="mailTo:info@agoffice.gov.mv" icon class="my-2" target="_blank" color="grey lighten-1">
                  <v-icon>mdi-email</v-icon>
              </v-btn>
          </div>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme

export default {
  props: ['navItems'],
  data: ()=>({
    news: {},
    currentUrl: 'window.location.href',
    items: [
      {
        text: 'ފުރަތަމަ ސަފްޙާ',
        disabled: false,
        href: '#/'
      },
      {
        text: 'މިނިސްޓްރީ',
        disabled: false,
        href: ''
      },
      {
        text: 'އެޓަރނީ ޖެނެރަލްގެ އޮފީސް',
        disabled: false,
        href: '#/'
      }
    ],
    loadingPage: true
  }),
  created() {
    this.$http.get(`${this.$url}/pagination/2/Media/Visits?&title.contains=${this.$route.params.guests}&limit=10&page=0&sort=id%20desc`).then((response)=>{
      this.news = response.data.data.rows
      this.loadingPage = false
    })
  },
  methods: {
    getImage(item) {
        if (item.Files && item.Files.length > 0) {
            let images = item.Files.filter(obj => obj.FileType.includes('image'))
            if (images.length > 0) {
            return `${this.$url}/downloadfile/${images[0].ID}`
            }
            else {
            return ''
            }
        }
        else {
            return ''
        }
    }
  }
}
</script>

<style lang="css">

[v-cloak] { display: none; }
.ql-editor p {
  line-height: 1.67 !important;
  padding-bottom: 10px;
  margin-bottom: 10px;
  
}
</style>